import * as actionTypes from "../action/actionTypes"
import {updateObject} from "../../shared/utility"
const initialState = {
    loading:false
}

const addAnimeStart = (state , action)=>{
    return updateObject(state , {loading:true} )
}
const addAnimeSuccess = (state , action)=>{
    return updateObject(state , {loading:false} )
}


const reducer = (state = initialState , action) =>{
switch(action.type){
    case actionTypes.ADD_ANIME_START:
        return addAnimeStart(state , action)
    case actionTypes.ADD_ANIME_SUCCESS:
        return addAnimeSuccess(state , action)
            default:
                return state
            
}   
}
export default reducer    


// WEBPACK FOOTER //
// ./src/store/reducer/addAnime.js